<script setup>
// definePageMeta({
//   layout: "blank",
// })

const props = defineProps({
  error: Object
})

</script>

<template>
    <div class="d-flex justify-center align-center text-center h-100">
        <div>
            <img src="/errorimg.svg" width="500" alt="404" />
            <h1 class="text-h1 pt-3">Error {{ error?.statusCode }}</h1>
            <h4 class="text-h4 my-8">{{ error?.statusMessage ?? 'This page you are looking for could not be found.' }}</h4>
            <v-btn flat color="primary" class="mb-4" to="/dashboard">Go Back to Home</v-btn>
        </div>    
    </div>
</template>
